import React, {Component} from 'react';
import QuestionInfo from '../components/QuestionInfo'
import QuestionList from '../components/QuestionList'
import Footer from '../components/Footer'
import InfoFooterApp from '../components/QuestionInfoFooter'
import Header from "../components/Header";

export default class Calculator extends Component {
    render() {

        return (
            <div className="content-wrapper " id="content">

                <Header title="Fristberegneren" front={true}/>

                <div className="inner container main-content">
                    <div className="row">
                        <div className="content-left content col-12 col-md-7 col-lg-6">
                            <div id="calculator-content">
                                <QuestionList/>
                            </div>
                        </div>
                        <div className="rightside sidebar col-12 col-md-5 col-lg-6" id="rightside">
                            <QuestionInfo/>
                        </div>
                    </div>
                </div>
                <Footer/>
                <InfoFooterApp/>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/views/Calculator.js